import React from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";

const DestinationSettingsSection = ({
  newPromotionName,
  setNewPromotionName,
}: {
  newPromotionName: string;
  setNewPromotionName: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("promotion_duplication.section.destination")}
      rows={[
        {
          label: t("promotion_duplication.field.new_promotion_name"),
          required: true,
          children: (
            <TextField
              size="small"
              value={newPromotionName}
              onChange={(e) => setNewPromotionName(e.target.value)}
              sx={{ minWidth: 400 }}
            />
          ),
        },
      ]}
    />
  );
};

export default DestinationSettingsSection;
